<template>
    <div class="main-box mh-a">
        <el-image width="100%" src="./static/img/core.png" fit="fit"></el-image>
        <!-- 核心技术展示 -->
        <ul v-for="(coreList, index) in coreList" :key="`${index}_core`" class="flex j-s-b flex-wrap cover-childen">
            <li v-for="(item, idx) in coreList" :key="`${idx}_item`" @click="clickChange(item, index, idx)"
                @mouseout="coreSelect = null" @mouseover="hoverChange(item.imgname)"
                class="w160px cover-size text-center mv10 core-item c-pointer">
                <img v-if="coreInfo.imgname !== item.imgname" class="h60px"
                    :src="coreSelect === item.imgname ? `/static/img/core/${item.imgname}_a.png` : `/static/img/core/${item.imgname}.png`"
                    :alt="item.title" />
                <img v-else class="h60px" :src="`/static/img/core/${item.imgname}_a.png`" :alt="item.title" />
                <p class="fs14 lh30"
                    :class="{ 'c-blue': coreSelect === item.imgname || coreInfo.imgname === item.imgname }">{{
            item.title }}</p>
            </li>
            <div v-if="coreInfo.imgname && coreIndex == index" class="core-box c-g-d mh-a p10 flex">
                <el-image class="cover-img" v-if="coreInfo.reveal" :src="coreInfo.reveal" fit="cover"></el-image>
                <div class="flex1 cover-m-text">
                    <h4 class="text-center pt20 fs16">{{ coreInfo.title }}</h4>
                    <div class="flex a-i-c h150px">
                        <p class="text-indent fs14 ph30">{{ coreInfo.desc.join("") }}</p>
                    </div>
                </div>
            </div>
        </ul>

        <!-- <div style="font-size: 20px;">AI算法平台</div>
        <div>
            <div style="width: 30%;">
                <div style="font-size: 16px;text-align: center;margin: 10px;">人工智能研发平台</div>
                <el-image src="./static/img/rebot.jpg" alt="" />
            </div>

        </div> -->
    </div>
</template>

<script>
// 核心技术列表
import CoreList from "@/assets/core/coreList";
import CoreListEn from "@/assets/core/coreList-en";
export default {
    name: "iristarCore",
    data() {
        return {
            coreSelect: null,
            coreInfo: {},
            coreIndex: null,
            itemIndex: null,
        };
    },
    computed: {
        coreList() {
            let coreList = this.$store.state.language === "zh" ? CoreList : CoreListEn;
            // 判断一下屏幕尺寸
            let innerW = window.innerWidth;
            let size = innerW > 768 ? 5 : 4;
            return this.chunk(coreList, size);
        },
    },
    methods: {
        hoverChange(name) {
            this.coreSelect = name;
        },
        clickChange(obj, index, idx) {
            if (this.itemIndex === idx && this.coreIndex === index) {
                this.coreInfo = {};
                this.itemIndex = null;
                this.coreIndex = null;
            } else {
                this.itemIndex = idx;
                this.coreIndex = index;
                this.coreInfo = obj;
            }
        },
        coreShow(index) {
            this.coreSelect === index ? (this.coreSelect = null) : (this.coreSelect = index);
        },
        chunk(array, size) {
            let [start, end, result] = [null, null, []];
            for (let i = 0; i < Math.ceil(array.length / size); i++) {
                start = i * size;
                end = start + size;
                result.push(array.slice(start, end));
            }
            return result;
        },
    }
};
</script>

<style lang="less"></style>
